import React from 'react';
export function Revelation() {
  const proxyItems = [{
    icon: '🧠',
    title: 'Estrategia IA',
    desc: 'El cerebro estratégico que diseña la lógica, el copy y la arquitectura de tu negocio digital en segundos.'
  }, {
    icon: '🎨',
    title: 'Diseño de Autoridad',
    desc: 'Interfaces tipo Apple/Stripe que convierten la estética en la moneda de la confianza global.'
  }, {
    icon: '⚡',
    title: 'Ingeniería Sintética',
    desc: 'Construye Web-Apps y Micro-SaaS funcionales con lenguaje natural. Sin código. Sin límites.'
  }, {
    icon: '💻',
    title: 'Refinamiento Pro',
    desc: 'Escala y perfecciona el código de tus proyectos para llevarlos al nivel enterprise.'
  }];
  return <section className="py-8 md:py-[120px] px-4 md:px-12 relative z-10" aria-label="El Despertar del Arquitecto" data-id="element-232">
      <div className="max-w-[900px] mx-auto text-center" data-id="element-233">
        <span className="section-tag" data-id="element-234">El Despertar</span>
        <h2 className="font-display text-[clamp(1.8rem,5vw,4.5rem)] leading-[1.1] tracking-[2px] mb-5 md:mb-12" data-id="element-235">
          "El código ya no es un lenguaje.
          <br data-id="element-236" />
          Es una{' '}
          <span className="text-gold drop-shadow-[0_0_15px_rgba(255,215,0,0.3)]" data-id="element-237">
            ORDEN.
          </span>
          <br data-id="element-238" />
          O das las órdenes,
          <br data-id="element-239" />o recibes las{' '}
          <span className="text-cyan drop-shadow-[0_0_15px_rgba(0,245,255,0.3)]" data-id="element-240">
            SOBRAS.
          </span>
          "
        </h2>
        <p className="font-text text-[0.88rem] md:text-[1.1rem] text-text-silver leading-[1.7] md:leading-[1.9] max-w-[700px] mx-auto mb-6 md:mb-16" data-id="element-241">
          En 2025, el mundo se divide en dos tipos de personas: los que{' '}
          <strong className="text-white" data-id="element-242">consumen IA</strong> para entretenerse
          y los que la <strong className="text-white" data-id="element-243">arquitectonizan</strong>{' '}
          para construir activos que valen miles de dólares. Hay una brecha de
          billones entre las empresas que necesitan infraestructura digital y
          las personas que saben construirla en minutos.{' '}
          <strong className="text-white" data-id="element-244">
            Tú estás a 30 días de cruzar esa brecha.
          </strong>
        </p>

        {/* Proxy Card */}
        <div className="bg-gradient-to-br from-gold-soft to-cyan-soft border border-border-glow rounded-xl p-5 md:p-12 text-left relative overflow-hidden" data-id="element-245">
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold to-cyan" aria-hidden="true" data-id="element-246" />
          <span className="absolute top-5 right-6 text-[0.6rem] tracking-[3px] text-gold/50 font-bold hidden md:block" aria-hidden="true" data-id="element-247">
            SISTEMA PROXY
          </span>
          <h3 className="font-display text-[1.5rem] md:text-[2rem] tracking-[3px] text-gold mb-4 md:mb-8" data-id="element-248">
            EL SISTEMA PROXY
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-249">
            {proxyItems.map((item, idx) => <div key={idx} className="flex flex-col gap-1.5" data-id="element-250">
                <span className="text-[1.2rem] md:text-[1.5rem]" aria-hidden="true" data-id="element-251">
                  {item.icon}
                </span>
                <h4 className="font-body text-[0.8rem] md:text-[0.9rem] font-bold text-white tracking-[1px]" data-id="element-252">
                  {item.title}
                </h4>
                <p className="text-[0.72rem] md:text-[0.8rem] text-text-muted leading-[1.5]" data-id="element-253">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}